import React from 'react'
import { Alert } from 'react-bootstrap'

const Message = ({variant = 'warning', text = 'black', timeout = 5000, children}) => {
  const  message = children;

  // If message is empty string nothing will be returned
  if ((message && message.length === 0) || (!message)) {
    return null;
  }

  return ( 
    <>
    { <Alert bg={variant} text={text} shadow="sm" mt="3" >
        {message} </Alert>}
    </>
  )
}

export default Message;
